<template>
  <form-section id="venue_governing_law" :headline="this.$t('form.venue_governing_law.legend')">
    <checkbox id="eeaOrEu" :label="$t('form.venue_governing_law.eea_or_eu.label')" v-model="venueGoverningLaw.eeaOrEu" />
  </form-section>
</template>

<script>
import FormSection from "@/shared/components/FormSection.vue";
import Checkbox from "@/shared/components/Checkbox";
export default {
  components: {
    Checkbox,
    FormSection
  },
  data() {
    return {
      venueGoverningLaw: {
        eeaOrEu: false
      }
    };
  },
  watch: {
    venueGoverningLaw: {
      handler() {
        this.$store.commit("updateVenueGoverningLaw", this.venueGoverningLaw);
      },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/form/VenueGoverningLawInput.vue